import Image from 'react-bootstrap/Image';
import Logo from '../../../../assets/logo.png';
const LogoLight = () => {
  return (
    <>
      <Image src={Logo} alt="Logo" className="img-fluid" width={100} />
    </>
  );
};
export default LogoLight;
